module.exports = __webpack_public_path__ + "img/profile-pic.2198759f.png";